import * as React from 'react';
import { LoadOptions } from 'app/types-shared';
import { CodeSinglePicker } from 'app/area/codetable/common';
import { ReadOnlyType } from 'app/area/codetable/item/types';
import { codetableOptionsIds } from 'app/area/codetable/item/screen-renderer/screen-pickers/constants';
import { ScreenPicker, ScreenPickerProps } from 'app/area/codetable/item/screen-renderer/types';
import { getDisabledValidation } from 'app/area/shared/codetable/item/codetable-item-helpers';
import { manageOptionsButton } from 'app/area/shared/manage-options';
import { CodeComplexValue } from 'app/area/shared/codetable/types';

export const InsuranceTypeConsequenceType = ({ codeItem, resetValidation, codetableOptions, translation, validation, readOnlyConfig,
  loadCodetableOptions, updateByKey
}: ScreenPickerProps) => {

  const onLoadOptions = (id: string, loadOptionsParams: LoadOptions) => {
    loadCodetableOptions(id, codetableOptionsIds.consequenceType, loadOptionsParams);
  };

  const onChange = (value: CodeComplexValue<number>) => {
    resetValidation(ScreenPicker.consequenceType);
    updateByKey(ScreenPicker.consequenceType, value);
  };

  const extraFooterButton = manageOptionsButton(translation.manage_options, codetableOptionsIds.consequenceType);

  const codeOptions = (codetableOptions?.[ScreenPicker.consequenceType]?.codes || []) as CodeComplexValue<number>[];
  const consequenceTypeValidation = !!validation?.[ScreenPicker.consequenceType] ? validation[ScreenPicker.consequenceType] : undefined;
  const finalValidation = {
    ...consequenceTypeValidation,
    ...getDisabledValidation(codeItem.consequenceType?.disabled, translation.selected_value_disabled)
  };
  const readOnly = readOnlyConfig && readOnlyConfig[ReadOnlyType.all];

  return (
    <CodeSinglePicker
      id={ScreenPicker.consequenceType}
      label={translation?.consequence_type}
      valueItem={codeItem?.consequenceType}
      searchRequired={false}
      required={false}
      options={codeOptions}
      fetchingOptions={codetableOptions?.[ScreenPicker.consequenceType]?.fetching}
      showSpinnerLabel={false}
      validation={finalValidation}
      translation={translation}
      extraFooterButton={extraFooterButton}
      onLoadOptions={onLoadOptions}
      onChange={onChange}
      readOnly={readOnly}
    />
  );
};
